import React, { FC } from 'react';
import Thumbnail from './thumbnail/thumbnail';
import './presenter-slide-thumbnails.scss';
import { useStore } from '../../../store/store-provider';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import {
  IPresenterSlideEntity
} from '../../../store/presenter-slide-management-store/presentation-config-aggregate/presenter-slide-entity/presenter-slide-entity';

interface ISelectedSlideWrapperProps {
  slideIndex: number;
}

// Wrapper which  add blue border for activeItem
// It was written for avoid unnecessary thumbnail list re-render
const SelectedSlideWrapper: FC<ISelectedSlideWrapperProps> = observer(({ children, slideIndex }) => {
  const { slideManagementStore } = useStore();
  const { getSlideManagementEntity, selectSlideInVerticalList } = slideManagementStore;
  const { getActivePointer } = getSlideManagementEntity();
  const isSelected: boolean = slideIndex === getActivePointer().getCurrentCuePointIndex();
  return (
    <li
      className={classnames('thumbnail', { 'thumbnail_selected': isSelected })}
      onClick={() => selectSlideInVerticalList(slideIndex)}
    >
      {children}
    </li>
  );
});

// Wrapper for handle Loading state during sending change mutation
// It was written for avoid unnecessary thumbnail list re-render
const LoadingWrapper: FC = observer(({ children })=>{
  const { slideManagementStore } = useStore();
  const { isLoading } = slideManagementStore;
  return (
    <ul
      className={classnames('presenter-thumbnails custom-scrollbar', {
        'presenter-thumbnails_disabled': isLoading
      })}
    >
      {children}
    </ul>
  );
});

const PresenterSlideThumbnails: FC = (): JSX.Element => {
  const { slideManagementStore } = useStore();
  const { getSlideManagementEntity } = slideManagementStore;
  const { getSlides, getNumberOfSlides } = getSlideManagementEntity();
  const additionalIndex = 1;
  return (
    <LoadingWrapper>
      {getNumberOfSlides() && getSlides().map((PresenterSlide: IPresenterSlideEntity, index: number) =>
        <SelectedSlideWrapper
          slideIndex={index}
          key={PresenterSlide.getCuePointId()}
        >
          <Thumbnail
            thumbnailSrc={PresenterSlide.getCuePointMetadata().smallThumbnail}
            title={PresenterSlide.getCuePointMetadata().title}
            thumbnailNumber={index + additionalIndex}
          />
        </SelectedSlideWrapper>
      )}
    </LoadingWrapper>
  );
};

export default observer(PresenterSlideThumbnails);